import { Badge } from '@consigli/shadcn';

import { workflowName } from './format';

interface WorkflowChipsProps {
  /** Turns started by each workflow, keyed by workflow id. */
  workflows: Record<string, number>;
}

export const WorkflowChips = ({ workflows }: WorkflowChipsProps) => {
  const runs = Object.entries(workflows);
  if (runs.length === 0) {
    return <span className="text-muted-foreground">None</span>;
  }
  return (
    <div className="flex max-w-xs flex-wrap gap-1">
      {runs.map(([workflowId, count]) => (
        <Badge key={workflowId} variant="secondary">
          {workflowName(workflowId)}
          {count > 1 && <span className="font-semibold">×{count}</span>}
        </Badge>
      ))}
    </div>
  );
};
